import React, { useState, useEffect, useContext } from "react";

import axios from "../../../axios/index";

// Context
import { UserContext } from "../../Context/UserContextProvider";

// styles
import Dstyles from "../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css";
import pageStyles from "../UserMyAds/UserMyAds.module.css";

// components
import HomeNavbar from "./../../Home/HomeNavbar/HomeNavbar";
import UserSideDashboard from "../UserSideDashboard/UserSideDashboard";
import Footer from "../../Home/Footer/Footer";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import UserChatCards from "./UserChatCards";
import CustomPagination from "../../CustomPagination/CustomPagination";

export default function UserChats() {
  const { userToken } = useContext(UserContext);

  if (userToken == null) {
    window.location.reload();
  }

  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState({
    pageNumber: 1,
    pageCount: 5,
  });

  const [chatData, setChatData] = useState();

  useEffect(() => {
    const dataHandler = async () => {
      // setIsLoading(true)
      const getData = await axios.get("Messages/UserMessagesByFilter", {
        headers: { authorization: "Bearer " + userToken },
      });
      setPage(prev => {
        return { ...prev, pageNumber: 1, pageCount: getData.data.data.pageCount };
      });
      setChatData(getData.data.data.data);
      setIsLoading(false);
    };

    dataHandler();
  }, [userToken]);

  return (
    <>
      {isLoading ? (
        <div className={Dstyles.loader_container}>
          <div className={Dstyles.spinner}></div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-start vw-100 position-relative" dir="rtl">
          <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
            <HomeNavbar />
            <div className="container py-3 px-0 mt-4">
              <div className="w-100 d-flex justify-content-md-between justify-content-center align-items-start">
                <UserSideDashboard chat />
                <div className={`d-flex flex-column align-items-center justify-content-start p-4 ${pageStyles.main_container}`}>
                  <div className="w-100 d-flex align-items-center justify-content-start flex-wrap mb-5">
                    <div className={`my-md-0 mt-3 mb-2 ${pageStyles.title}`}>چت با مشاوران</div>
                  </div>

                  <UserChatCards chatData={chatData} />

                  <Stack
                    className={Dstyles.pagination}
                    spacing={1}
                    sx={{
                      direction: "ltr",
                      bottom: "0",
                      height: "85px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center !important",
                    }}>
                    {/* <Typography>Page: {page}</Typography> */}
                    <CustomPagination count={page.pageCount} variant="outlined" shape="rounded" page={page.pageNumber} onChange={paginationHandler} />
                  </Stack>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      )}
    </>
  );

  async function paginationHandler(event, value) {
    setIsLoading(true);
    const getData = await axios.get(`Messages/UserMessagesByFilter?PageId=${value}`, {
      headers: { authorization: "Bearer " + userToken },
    });
    setPage(prev => {
      return { ...prev, pageCount: getData.data.data.pageCount, pageNumber: value };
    });
    setChatData(getData.data.data.data);
    setIsLoading(false);
  }
}
